var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', {
    attrs: {
      "offset-y": "",
      "allow-overflow": "",
      "max-height": "80%",
      "min-width": "240",
      "close-on-click": false,
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs,
          value = _ref.value;
        return [_vm._t("default", function () {
          return [_c('v-btn', _vm._g({
            directives: [{
              name: "blur",
              rawName: "v-blur"
            }],
            attrs: {
              "icon": "",
              "input-value": value,
              "color": value ? 'orange' : null
            }
          }, on), [_c('v-icon', {
            domProps: {
              "innerHTML": _vm._s(_vm.mdiTag)
            }
          })], 1)];
        }, null, {
          on,
          attrs
        })];
      }
    }], null, true),
    model: {
      value: _vm.open,
      callback: function ($$v) {
        _vm.open = $$v;
      },
      expression: "open"
    }
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.addTagStatus
    }
  }, [_vm._v(" Error adding tag – note that you cannot add multi-word tags unless they match an existing category ")]), _c('error-dialog', {
    attrs: {
      "status": _vm.removeTagStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.updateTagScoreStatus
    }
  }), _c('div', {
    staticClass: "white"
  }, [_c('div', {
    staticClass: "px-2 overline"
  }, [_vm._v("Tags")]), _vm._l(_vm.tags, function (_ref2) {
    var tagId = _ref2[0],
      tag = _ref2[1];
    return (_vm.isAdmin || tag.tag) && !['new', 'free', 'template'].includes(tag.stem) ? _c('div', {
      key: tagId,
      staticClass: "d-flex align-center px-2",
      class: {
        blue: tagId == _vm.duplicateTagId
      }
    }, [tag.tag || _vm.isAdmin ? _c('div', {
      staticClass: "flex-grow-1 text--label-active",
      class: {
        'font-italic grey--text': !tag.tag
      }
    }, [_vm._v(" " + _vm._s(tag.tag || 'Overall score') + " ")]) : _vm._e(), _vm.isAdmin ? _c('v-text-field', {
      staticClass: "flex-grow-0 my-0",
      staticStyle: {
        "width": "34px"
      },
      attrs: {
        "dense": "",
        "hide-details": "",
        "color": tag._score == tag.score ? null : 'amber',
        "error": Number(tag._score) != tag._score || tag._score <= 0 || tag._score > 1,
        "loading": _vm.updateTagScoreStatus.pending
      },
      on: {
        "keydown": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
          return _vm.updateTagScore(tagId, tag);
        },
        "blur": function ($event) {
          tag._score = tag.score;
        }
      },
      model: {
        value: tag._score,
        callback: function ($$v) {
          _vm.$set(tag, "_score", $$v);
        },
        expression: "tag._score"
      }
    }) : _vm._e(), _c('v-btn', {
      staticClass: "ml-1",
      attrs: {
        "icon": "",
        "disabled": !tag.tag || !_vm.isAdmin && tag.tag.startsWith('#')
      },
      on: {
        "click": function ($event) {
          return _vm.removeTag(tagId);
        }
      }
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiClose)
      }
    })], 1)], 1) : _vm._e();
  }), _vm.isAdmin || !_vm.readonly ? _c('div', {
    staticClass: "px-2 pb-2 d-flex align-center"
  }, [_c('v-combobox', {
    ref: "new-tag",
    staticClass: "mt-0",
    attrs: {
      "dense": "",
      "hide-details": "",
      "autofocus": "",
      "items": _vm.categoryNames,
      "loading": _vm.loadCategoryNamesStatus.pending || _vm.addTagStatus.pending,
      "disabled": _vm.addTagStatus.pending,
      "search-input": _vm.newTagInput
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.newTagInput = $event;
      },
      "update:search-input": function ($event) {
        _vm.newTagInput = $event;
      },
      "change": _vm.addTag
    },
    model: {
      value: _vm.newTag,
      callback: function ($$v) {
        _vm.newTag = $$v;
      },
      expression: "newTag"
    }
  }), _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "icon": "",
      "color": "primary",
      "disabled": !_vm.newTagInput
    },
    on: {
      "click": _vm.addTag
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPlus)
    }
  })], 1)], 1) : _vm._e()], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }